import { render, staticRenderFns } from "./searchResult.vue?vue&type=template&id=54fd8c7e"
import script from "./searchResult.vue?vue&type=script&lang=js"
export * from "./searchResult.vue?vue&type=script&lang=js"
import style0 from "./searchResult.vue?vue&type=style&index=0&id=54fd8c7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports